import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  registerSentenceCase: {
    id: 'general.register.sentenceCase',
    defaultMessage: 'Register',
    description: 'Text in a button, prompting the user to register.',
  },
  signInSentenceCase: {
    id: 'general.signIn.sentenceCase',
    defaultMessage: 'Sign in',
    description: 'Text in a button, prompting the user to log in.',
  },
});

export default messages;
